<template lang="pug">
    .settings(v-if='settings')
        template(v-if="!onlyMultOrDivChosen")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}:
            | {{ $i18n.t('common')[settings.difficult] + (settings.combining ? ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : '') }}
            br
        template(v-else)
            template(v-if="!onlyDivChosen")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                | {{ digitCapacityNames[MultDivLeftHighestCapacity] + (isMultDivLeftCombiningEnabled ? ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : '') }}
                br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}:
            | {{ digitCapacityNames[MultDivRightHighestCapacity] + (isMultDivRightCombiningEnabled ? ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : '') }}
            br
        template(v-if="parametersFrom === 'homework'")
            template(v-if='settings.mode')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ settings.mode }}
                br
            template(v-if='settings.numberAmount')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') }}: {{ settings.numberAmount }}
                br
            template(v-if="settings.timeForAnswer != '-1'")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}:
                | {{ settings.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
                br
            template(v-if='settings.amountOfExamples')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
                br
            template(v-else-if='settings.timeLimit')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}:
                | {{ settings.timeLimit }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
                br
            template
                | {{ $i18n.t('trainer.trainer_gameSetting_pairsOfBrackets') }}: {{ abbreviatedValueOfSetting(settings.bracketsEnabled) }}
                br
            template(v-if='settings.bracketsEnabled && settings.bracketAmount')
                | {{ $i18n.t('trainer.trainer_gameSetting_amountOfBracketPairs') }}: {{ settings.bracketAmount }}
                br
            template(v-if='settings.operations')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}: {{ rulesArrayToString(chosenOperations) }}
                br
            template(v-if='settings.negativeAnswers')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                br
            template(v-if='settings.fractions')
                span
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                    | {{ fractionalPart }}
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                br
        slot
</template>

<script>
    import preview from '../../../utils/expressions/preview';

    export default {
        mixins: [preview],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: Number,
        },
        computed: {
            fractionalPart() {
                return (
                    this.settings.fractionalPart +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_numDeclination', this.settings.fractionalPart)
                );
            },
        },
    };
</script>
